// This is only created so we can verify that the Besta leg component has an id that does not conflict with another components ids.
// It's used for the selected leg component that is added with the legs system
class BestaFrameLegsSystemComponent {
    constructor() {
        this.typeId = BestaFrameLegsSystemComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
    }
    eq() {
        return false;
    }
}
BestaFrameLegsSystemComponent.id = 2002;
export default BestaFrameLegsSystemComponent;
//# sourceMappingURL=BestaFrameLegsSystemComponent.js.map